import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../../lib/api";
import { useLang } from "../../contexts/LanguageContext";
import PageHero from "../../components/public/PageHero";
import { usePageSeo, htmlToText } from "../../components/public/seo/PageSeo";

export default function StaticPage({ slug: forcedSlug }) {
  const params = useParams();
  const slug = forcedSlug || params.slug || params.servicio;
  const { pick } = useLang();
  const [page, setPage] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    setPage(null);
    setError(false);
    if (!slug) return;
    api.get(`/pages/${slug}`)
      .then((r) => setPage(r.data))
      .catch(() => setError(true));
  }, [slug]);

  usePageSeo(page ? {
    title: `${pick(page, "title")} · CECIT`,
    description: pick(page, "meta_description") || pick(page, "subtitle") || htmlToText(pick(page, "body")),
    image: page.hero_image || null,
    type: "article",
  } : null);

  if (error) {
    return (
      <div className="min-h-[50vh] flex items-center justify-center text-gray-500">
        Page not found.
      </div>
    );
  }
  if (!page) {
    return <div className="min-h-[50vh] flex items-center justify-center text-gray-400">Loading…</div>;
  }

  const body = pick(page, "body");
  const isHTML = /<[a-z][\s\S]*>/i.test(body);

  return (
    <div data-testid={`static-page-${slug}`}>
      <PageHero title={pick(page, "title")} subtitle={pick(page, "subtitle")} image={page.hero_image} />
      <article className="max-w-3xl mx-auto px-6 py-20">
        {isHTML ? (
          <div className="prose-cecit text-gray-700 text-lg" dangerouslySetInnerHTML={{ __html: body }} />
        ) : (
          <div className="prose-cecit text-gray-700 leading-relaxed text-lg">
            {body.split(/\n\n+/).map((para, i) => {
              if (para.startsWith("## ")) {
                return <h2 key={i}>{para.slice(3)}</h2>;
              }
              return <p key={i}>{para}</p>;
            })}
          </div>
        )}
      </article>
    </div>
  );
}
